import { render, staticRenderFns } from "./beautyEdit.vue?vue&type=template&id=688f01d4&scoped=true&"
import script from "./beautyEdit.vue?vue&type=script&lang=js&"
export * from "./beautyEdit.vue?vue&type=script&lang=js&"
import style0 from "./beautyEdit.vue?vue&type=style&index=0&id=688f01d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f01d4",
  null
  
)

export default component.exports